import { Plugin } from '../../renderer';
export class EventHandlerPlugin extends Plugin {
    priority() {
        return Plugin.PriorityFallback;
    }
    setProp(node, prop, target) {
        if (prop.startsWith('on') && typeof target === 'function') {
            const event = prop.substr(2).toLowerCase();
            node.addEventListener(event, target);
            return true;
        }
        return false;
    }
}
//# sourceMappingURL=event-handler.plugin.js.map